var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.queue),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"filename"},[_vm._v(" "+_vm._s(item.file.name))]),_c('el-progress',{attrs:{"percentage":parseInt(item.progress*100),"color":'#67c23a'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }